module.exports = function () {

    switch (process.env.NODE_ENV) {
        case 'staging':
            return new staging;
        case 'production':
            return new production;
        default:
            return new development;
    }
}

class baseConfiguration {
    REGION = "us-east-1";
}

class development extends baseConfiguration {
    APPSYNC_URI = 'https://wv6necezubdptflnugvbjag32u.appsync-api.us-east-1.amazonaws.com/graphql';
    IDENTITY_POOL_ID = "us-east-1:98770306-52a8-4640-8c3b-faadcd2410c6";
    USER_POOL_LOGIN_ID = "cognito-idp.us-east-1.amazonaws.com/us-east-1_sQVLBNWhL";
    USER_POOL_ID = "us-east-1_sQVLBNWhL";
    CLIENT_ID = "2fiavv9idkqa6s7qtlkq540afd";
    DOMAIN = "gym-reservation-production.auth.us-east-1.amazoncognito.com";
}

class staging extends baseConfiguration {
    APPSYNC_URI = 'https://moepp5omvber5imivqi7odedxi.appsync-api.us-east-1.amazonaws.com/graphql';
    IDENTITY_POOL_ID = "us-east-1:08df37db-f083-4cfa-862a-10ce51b772bd";
    USER_POOL_LOGIN_ID = "cognito-idp.us-east-1.amazonaws.com/1_TGgSdhOrw";
    USER_POOL_ID = "us-east-1_TGgSdhOrw";
    CLIENT_ID = "2kkt2gciiu437vl7mst98uvasu";
    DOMAIN = "gym-reservation-staging.auth.us-east-1.amazoncognito.com";
}

class production extends baseConfiguration {
    APPSYNC_URI = 'https://wv6necezubdptflnugvbjag32u.appsync-api.us-east-1.amazonaws.com/graphql';
    IDENTITY_POOL_ID = "us-east-1:98770306-52a8-4640-8c3b-faadcd2410c6";
    USER_POOL_LOGIN_ID = "cognito-idp.us-east-1.amazonaws.com/us-east-1_sQVLBNWhL";
    USER_POOL_ID = "us-east-1_sQVLBNWhL";
    CLIENT_ID = "2fiavv9idkqa6s7qtlkq540afd";
    DOMAIN = "gym-reservation-production.auth.us-east-1.amazoncognito.com";
}
